export const GET_LOCATION_PROFILE = 'GET_LOCATION_PROFILE';
export const CLEAR_LOCATION_STORE = 'CLEAR_LOCATION_STORE';
export const SEND_INVITATION = 'SEND_INVITATION';
export const CLEAR_STORES = 'CLEAR_STORES';



// WEBPACK FOOTER //
// ./src/app/stores/company/location/location-constants.js